module.exports = __webpack_public_path__ + "static/media/pin.eba4a247.svg";